export default [
  {
    title: 'Compass',
    icon: '/images/landing/try-roomvu/brokerages/compass.png',
  },
  {
    title: "Sotheby's International Realty",
    icon: '/images/landing/try-roomvu/brokerages/sothebys.png',
  },
  {
    title: 'Redfin',
    icon: '/images/landing/try-roomvu/brokerages/redfin.png',
  },
  {
    title: 'Zillow',
    icon: '/images/landing/try-roomvu/brokerages/zillow.png',
  },
  {
    title: 'Better Homes Real Estate',
    icon: '/images/landing/try-roomvu/brokerages/better-homes.png',
  },
  {
    title: 'Keller Williams',
    icon: '/images/landing/try-roomvu/brokerages/keller-williams.png',
  },
  {
    title: 'Camden',
    icon: '/images/landing/try-roomvu/brokerages/camden.png',
  },
  {
    title: '21 Century Realty',
    icon: '/images/landing/try-roomvu/brokerages/century-21.png',
  },
  {
    title: 'Coldwell Banker Realty',
    icon: '/images/landing/try-roomvu/brokerages/coldwell-banker.png',
  },
  {
    title: 'Corcoran Group Real Estate',
    icon: '/images/landing/try-roomvu/brokerages/corcoran.png',
  },
  {
    title: 'RE/MAX',
    icon: '/images/landing/try-roomvu/brokerages/remax.png',
  },
  {
    title: 'ERA Real Estate Realty Group',
    icon: '/images/landing/try-roomvu/brokerages/era.png',
  },
];
